import React from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";
import "./App.css";

import MainPage from "src/pages/MainPage";
import PreviewPage from "src/pages/PreviewPage";

function App() {

    return (
        <Router>

            <Route exact path="/:uuid.html">
                <MainPage/>
            </Route>

            <Route exact path="/:uuid/:uuidElement.html">
                <MainPage/>
            </Route>

            <Route exact path="/preview">
                <PreviewPage/>
            </Route>

        </Router>
    )

}

export default App;
